import { Box, ClickAwayListener, Divider, Grow, MenuItem, MenuList, Paper, Popper, Stack } from '@mui/material';
import React, { FC } from 'react';

import { Icon } from '@iconify/react';
import Button from '../../components/Button/Button';
import { LoadingDialogue } from '../../components/Spinners';
import TextField from '../../components/TextField/TextField';
import { useQuickFilter } from '../../hooks/useQuickFilter';
import useSnackbarNotifications from '../../hooks/useSnackbarNotifications';
import { exportData } from '../../services/export';
import MultipleVinsContainer from '../VehiclesGrid/MultipleVinsContainer';

type Props = {
  onSearch: (searchText: string) => void;
  onToggleToolPanelClick: (panelId: 'columns' | 'filters') => void;
  filteredVins: any;
  setInputText: any;
  inputText: any;
  setFilteredVins: any;
  paginationInfo?: any;
  uiHeadings?: any;
};

const GridTopActions: FC<Props> = ({
  onSearch,
  onToggleToolPanelClick,
  filteredVins,
  setInputText,
  inputText,
  setFilteredVins,
  paginationInfo,
  uiHeadings,
}) => {
  const { quickFilterParser, quickFilterMatcher, parseMultipleSearchText, multipleSearch } = useQuickFilter();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);
  const [exportOpen, setExportOpen] = React.useState(false);
  const { showSuccessSnackbar, showErrorSnackbar } = useSnackbarNotifications();

  const inputHandler = (e: any) => {
    setInputText(e.target.value);
    // onSearch(e.target.value);
    const parsed = parseMultipleSearchText(e.target.value);
    if (multipleSearch(parsed)) {
      setInputText(parsed);
      setFilteredVins(parsed);
    }
    // eslint-disable-next-line react/no-array-index-key
    if (e.target.value === '') {
      setFilteredVins([]);
    }
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event | React.SyntheticEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }

    setOpen(false);
  };

  const handleExport = async (type: string, event: Event | React.SyntheticEvent) => {
    handleClose(event);
    setExportOpen(true);
    try {
      const message = await exportData(type, 'Inventory', paginationInfo, inputText, uiHeadings);
      if (message !== 'Success') {
        setExportOpen(false);
        throw new Error(message);
      } else {
        setExportOpen(false);
        showSuccessSnackbar({
          message: `The exported file is successfully sent to your email. Please check your Inbox.`,
        });
      }
    } catch (error) {
      console.log(error);
      showErrorSnackbar({ message: 'Error in sending the exported file.' });
    }
  };

  return (
    <Stack p={1}>
      <Stack direction="row" alignItems="center" gap={2} justifyContent="flex-end">
        <LoadingDialogue open={exportOpen} message="Please wait." />
        <Box width="100%">
          <TextField
            placeholder="Search..."
            sx={{ maxWidth: '100%' }}
            fullWidth
            value={inputText}
            endIcon={<Icon icon="ant-design:search-outlined" />}
            onChange={(e) => inputHandler(e)}
          />
        </Box>
        <Box sx={{ minWidth: '140px' }}>
          <Button
            size="small"
            startIcon={<Icon icon="fluent:column-triple-20-regular" />}
            onClick={() => onToggleToolPanelClick('columns')}
          >
            Manage Columns
          </Button>
        </Box>
        <Divider orientation="vertical" flexItem />
        <Box>
          <Button
            size="small"
            startIcon={<Icon icon="cil:list-filter" />}
            onClick={() => onToggleToolPanelClick('filters')}
          >
            Filters
          </Button>
        </Box>
        <Divider orientation="vertical" flexItem />
        <Box>
          <Button
            sx={{ border: `1px solid #456BD9`, borderRadius: 1, minWidth: '120px' }}
            size="small"
            ref={anchorRef}
            onClick={handleToggle}
            endIcon={<Icon icon="akar-icons:chevron-down" />}
          >
            Export
          </Button>
          <Popper open={open} anchorEl={anchorRef.current} role={undefined} placement="bottom-start" transition>
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom',
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList
                      autoFocusItem={open}
                      id="composition-menu"
                      aria-labelledby="composition-button"
                      // overflow="visible"
                      // onKeyDown={handleListKeyDown}
                    >
                      <MenuItem onClick={(e) => handleExport('csv', e)}>CSV Export</MenuItem>
                      <MenuItem onClick={(e) => handleExport('excel', e)}>Excel Export</MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </Box>
      </Stack>
      {filteredVins?.length > 1 && (
        <MultipleVinsContainer
          filteredVins={filteredVins}
          setFilteredVins={setFilteredVins}
          // onSearch={onSearch}
          setInputText={setInputText}
        />
      )}
    </Stack>
  );
};

export default GridTopActions;
